/* eslint-disable */
import { Injectable } from '@angular/core';
import { BaseHttpService, ResourceHelper } from '../../util/http-services';
import { Observable } from 'rxjs';
import { ResourceQueryResult } from '../../util/services';
import { EmptyMessage } from '../../util/messages';
import { HttpClient } from '@angular/common/http';
/* eslint-enable */

@Injectable()
export class SmsTemplateResourceService extends BaseHttpService {

  query(request: SmsTemplateResource.QueryRequest): Observable<ResourceQueryResult<SmsTemplateResource.SmsTemplate>> {
    return this.http.get<ResourceQueryResult<SmsTemplateResource.SmsTemplate>>(this.url, this.parseParams(request));
  }

  get(request: SmsTemplateResource.GetRequest): Observable<SmsTemplateResource.SmsTemplate> {
    return this.http.get<SmsTemplateResource.SmsTemplate>(this.url + `${request.id}`);
  }

  create(request: SmsTemplateResource.CreateRequest): Observable<EmptyMessage> {
    return this.http.post(this.url, request);
  }

  update(request: SmsTemplateResource.UpdateRequest): Observable<EmptyMessage> {
    return this.http.put(this.url + `${request.id}`, request);
  }

  disable(request: SmsTemplateResource.DisableRequest): Observable<EmptyMessage> {
    return this.http.patch(this.url + `${request.id}` + '/disabled', request);
  }

  constructor(private http: HttpClient, resourceHelper: ResourceHelper) {
    super(resourceHelper, '/sms-templates/');
  }

}

export namespace SmsTemplateResource {

  export interface SmsTemplate {
    id: number;
    external_id: string;
    name: string;
    template: string;
    disabled: boolean;
    creation_time: string;
    update_time: string;
  }

  export interface QueryRequest {
    id?: string;
    external_id?: string;
    name?: string;
    disabled?: boolean;
    q?: string;
    order?: string;
    page_number?: number;
    number_of_items?: number;
    no_progress_bar?: boolean;
  }

  export interface GetRequest {
    id: number;
  }

  export interface CreateRequest {
    external_id?: string;
    name: string;
    template: string;
  }

  export interface UpdateRequest {
    id: number;
    external_id: string;
    name: string;
    template: string;
  }

  export interface DisableRequest {
    id: number;
    disabled: boolean;
  }

}
